/* The app's ONE visually-hidden treatment — a stylesheet with no component, the same shape as
 * `photoBox.module.css`, `emberButton.module.css` and `skeleton.module.css` beside it.
 *
 * ── What it is for ─────────────────────────────────────────────────────────────────────────────
 * Text that belongs in the accessibility tree and nowhere on the screen: the sentence that says
 * what an em dash MEANS, the fuller name behind a terse visible label, the reason a refused control
 * is refused, a live region, a card's "loading" word beside its `aria-busy`. `display: none` and
 * `hidden` are not alternatives — both take the text out of the accessibility tree with it, which
 * is the one thing these spans exist to prevent.
 *
 * ── `fixed`, not `absolute`, and that is MEASURED ──────────────────────────────────────────────
 * An absolutely positioned box with no positioned ancestor is laid out against the INITIAL
 * containing block, and it contributes to the DOCUMENT's scrollable overflow even sitting at its
 * own static position. Every one of these sits inside a pane that scrolls itself, so at 1280x620
 * the client detail's page grew to 759px while its tabs were loading and shrank back to 620 when
 * they answered — a page-level scrollbar that appears for half a second and takes the layout's
 * width with it. Measured by deleting the spans in the running page: 759 → 620, exactly.
 *
 * `fixed` takes it out of the document's flow AND out of its overflow. It is one clipped pixel at
 * the viewport's corner, so nothing is drawn and nothing is displaced.
 *
 * ── When a copy is still right ─────────────────────────────────────────────────────────────────
 * A FOCUSABLE control hidden this way keeps its own rule, positioned against its own label — a
 * radio behind a styled tab, a skip link. The browser scrolls a focused element into view, and one
 * pinned to the viewport's corner has nowhere to be scrolled to; those are a different problem with
 * a different answer, and `RosterToolbar`'s `.tabInput` and `shared/ui/skipLink` say so where they
 * are written.
 */

.srOnly {
  position: fixed;
  inset: 0 auto auto 0;
  width: var(--space-1px);
  height: var(--space-1px);
  overflow: hidden;
  clip-path: inset(50%);
  white-space: nowrap;
}
